import type { MatchSyncStatus } from "@livcg/schema";

const PFL_GRACE_MS = 5 * 60_000;
const STALE_MS = 3 * 60_000;

export function bannerFor(
  s: MatchSyncStatus | undefined,
  now: number,
): { text: string; action: "mapping" | null } | null {
  if (!s || now - s.lastRunAt > STALE_MS) return null;
  const pfl = s.errors.find((e) => (e.step === "pfl" || e.step === "standings") && now - e.since >= PFL_GRACE_MS);
  if (pfl) return { text: `PFL bilan aloqa yo'q (${Math.floor((now - pfl.since) / 60_000)} daq)`, action: null };
  const d = s.dostats;
  if (d && !d.matchLinked) return { text: "dostats: o'yin topilmadi — Sozlash", action: "mapping" };
  if (d?.lineupReady && d.unmappedStarters > 0)
    return { text: `dostats: ${d.unmappedStarters} o'yinchi bog'lanmadi — Sozlash`, action: "mapping" };
  return null;
}
